import axios from 'axios';
import { getCategoryName } from 'Pages/Home/Helper/Formatter';
import {
  API_BASE_URL,
  GET_ALL_BRANDS,
  GET_ALL_SIZES
} from '../constants';

const categoryString = (category = "") => {
  switch (category) {
    case "sneakers":
      return "sneakers"
    case "streetwear":
    case "fashion":
    case "apparels":
    case "apparel":
      return "apparels"
    case "luxury":
    case "handbags":
      return "handbags"
    case "lifestyle":
    case "toys":
    case "electronics-collectibles":
    case "lifestyles":
      return "lifestyles"
    case "madeindonesia":
      return "madeindonesia"

    default: return ""
  }
}

export const getAllBrands = (query) => (dispatch) => {
  const param = {
    params: {
      category: categoryString(query?.params?.category),
    }
  }
  return new Promise((resolve, reject) => {
    axios.get(`${API_BASE_URL}/brands`, param)
      .then((res) => {
        dispatch({
          type: GET_ALL_BRANDS,
          payload: res.data,
        });
        resolve(res.data.data);
      })
      .catch(err => {
        // console.log(err);
      });
  });
};

export const getAllSizes = (query) => dispatch => {
  return axios.get(`${API_BASE_URL}/sizes`, query)
    .then(res => {
      dispatch({
        type: GET_ALL_SIZES,
        payload: res.data
      });
      return res;
    })
    .catch(err => {
      // console.log(err);
    })
}
